module.exports = __webpack_public_path__ + "media/packs/images/track-fetching-46ab6d8546c90115ed5204cd0ad6928f.svg";